import { render, staticRenderFns } from "./AddressCreateEditModal.vue?vue&type=template&id=f5bf13fa&"
import script from "./AddressCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./AddressCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports